import * as Tooltip from "@radix-ui/react-tooltip";
import classNames from "classnames/bind";
import React from "react";
import { Icon } from "../../../Icon";
import { stripInvalidPropsForElement } from "../../../utils/component-props";
import styles from "./InputDescription.module.scss";
import type { InputDescriptionProps } from "./types";
import { Skeleton } from "../../../Skeleton";

const cx = classNames.bind(styles);

/**
 * Renders the input's long-form description - as an information icon with the
 * description in a tooltip.
 */
export const InputDescription = ({
  children,
  iconProps,
  tooltipContentProps,
  isDisabled = false,
  isLoading = false,
  isBusy = false,
  ...restProps
}: InputDescriptionProps) => {
  return (
    <Tooltip.Provider delayDuration={100}>
      <Tooltip.Root>
        <Tooltip.Trigger
          {...stripInvalidPropsForElement(restProps, "button")}
          className={cx("tooltip-trigger", restProps?.className)}
          type="button"
          disabled={isDisabled}
          aria-disabled={isDisabled}
        >
          <Icon
            variant="info"
            weight="bold"
            size={16}
            {...iconProps}
            className={cx("icon", iconProps?.className)}
            data-testid="input-description-tooltip-trigger"
          />
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            sideOffset={8}
            {...tooltipContentProps}
            className={cx("tooltip-content", tooltipContentProps?.className)}
          >
            <Skeleton
              isLoading={isLoading}
              isBusy={isBusy}
            >
              {children}
            </Skeleton>
            <Tooltip.Arrow className={cx("tooltip-arrow")} />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
